import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './OfflineWork.css'

const OfflineWork = () => {
    return (
        <>
            <div className='container offlineWorkCardContainer pt-5'>
                <div className='offlineWorkCardBox my-md-4'>
                    <div className='col-lg-6 col-md-6 col-sm-12 offlineWorkimg'>
                        <LazyLoadImage
            effect="blur"
 src="https://blueberrywebsites.azureedge.net/bbt/images/offlineWork.png" alt="" className='offlineWorkTravelimg' loading="lazy"  />
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mt-md-5'>
                        <h1 className='headings mt-2  offlineWorkCardHeading ps-2'><span>Partnering Globally</span>  for Efficient Travel
                        </h1>
                        <ul className='fs-5 ms-4 p-0 offline-list'>
                            <li className='circle-color'>Expert account managers for car rental, MICE, groups, and tour programs.</li>
                            <li className='circle-color'>Effortless group booking and charter services
                            </li>
                            <li className='circle-color'>Instant online availability and confirmation</li>
                            <li className='circle-color'>Personalized itineraries to suit every need and budget
                            </li>
                        </ul>
                    </div>


                </div>
            </div>
        </>
    )
}

export default OfflineWork